import { TFunction } from "i18next";

const getErrorCode = (error: unknown): string => {
  const source = error as { code?: string; name?: string };
  return source.code ?? source.name ?? "UnknownError";
};

export const getLocalizedAuthErrorMessage = (
  error: unknown,
  t: TFunction,
): string => {
  const code = getErrorCode(error);
  const key = `auth.cognitoErrors.${code}`;
  const translated = t(key);

  if (translated !== key) {
    return String(translated);
  }

  return error instanceof Error ? error.message : String(t("common.tryAgain"));
};

export const getAuthErrorCode = (error: unknown): string => getErrorCode(error);